import {Injectable} from '@angular/core';

export type MotivoSalidaVenta = 'navegacion' | 'contexto' | 'traspaso';

/** Editor de venta activo que debe dejar su trabajo a salvo antes de que se cambie de pantalla o de contexto. */
export interface EditorVentaProtegido {
    antesDeSalir(motivo: MotivoSalidaVenta): Promise<boolean>;
}

/**
 * Coordinador único de salidas voluntarias (plan POS v4 §8.1): el cambio de empresa/sede/estación y la navegación
 * consultan aquí ANTES de despachar. Sin editor registrado responde de inmediato que sí, así que no altera las
 * pantallas que no lo usan.
 */
@Injectable({providedIn: 'root'})
export class CoordinadorSalidaVentaService {
    private editor: EditorVentaProtegido = null;
    private enCurso: Promise<boolean> = null;

    /** Registra el editor activo; devuelve la función para retirarlo. */
    registrar(editor: EditorVentaProtegido): () => void {
        this.editor = editor;
        return () => {
            if (this.editor === editor) { this.editor = null; }
        };
    }

    get activo(): boolean {
        return !!this.editor;
    }

    /** Pide al editor que guarde; dos solicitudes simultáneas comparten la misma respuesta. */
    solicitarSalida(motivo: MotivoSalidaVenta): Promise<boolean> {
        if (!this.editor) { return Promise.resolve(true); }
        if (!this.enCurso) {
            const editor = this.editor;
            this.enCurso = editor.antesDeSalir(motivo).catch(() => false).finally(() => this.enCurso = null);
        }
        return this.enCurso;
    }
}
